





















import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import PreventiveMaintenanceMainTable from "@/views/App/PredictiveMaintenance/PreventiveMaintenance/PreventiveMaintenanceMainTable.vue";
import InstallationsPreventiveStatusSummary from "@/views/App/PredictiveMaintenance/PreventiveMaintenance/InstallationsPreventiveStatusSummary.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import {
    FetchInstallationsPreventiveMaintenanceStatusCommand,
    FetchInstallationsPreventiveMaintenanceStatusReqData,
} from "@/model/communication/componentsMaintenance/FetchInstallationsPreventiveMaintenanceStatusCommand";
import { FetchInstallationsPreventiveMaintenanceStatusResponse } from "@/model/communication/componentsMaintenance/FetchInstallationsPreventiveMaintenanceStatusResponse";
import { MaintenanceStatusEnum } from "@/model/data/status/MaintenanceStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        InstallationsPreventiveStatusSummary,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            PreventiveMaintenanceMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
            loadingSummary: false,
            totalsByStatus: new Map<MaintenanceStatusEnum, number>(),
            filteredTotalsByStatus: new Map<MaintenanceStatusEnum, number>(),
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                this.loadingSummary = true;
                let response: FetchInstallationsPreventiveMaintenanceStatusResponse = await new FetchInstallationsPreventiveMaintenanceStatusCommand(request).execute();
                this.loadingSummary = false;
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                    this.totalsByStatus = response.totalCountByStatus;
                    this.filteredTotalsByStatus = response.filteredTotalCountByStatus;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new FetchInstallationsPreventiveMaintenanceStatusReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
